import { connect } from 'react-redux';

import UpsellBanner from '../components/sidebar/UpsellBanner';
import {
  getLineItemsSubscribableQuantity,
  getNumOfSubscribableItemsReqToCheckout,
  getOfferingName,
  hasOrderLineItemWithOfferingId,
} from '../selectors';

const mapStateToProps = state => {
  return {
    canBecomeMember: state.canBecomeMember,
    evergreenOffering: state.evergreenOffering,
    evergreenOfferingName: getOfferingName(state.evergreenOffering, state),
    freeShippingAmount: state.freeShippingAmount,
    hasSubscriptionCommitment: state.currentOrder.has_subscription_commitment,
    isMembershipOrder: state.currentOrder.membership_order,
    minimumSubscriptionItems: state.minimumSubscriptionItems,
    orderContainsEvergreenOffer: state.evergreenOffering
      ? hasOrderLineItemWithOfferingId(
          state.currentOrder,
          state.evergreenOffering.id
        )
      : false,
    requiredInstallmentCount: state.evergreenOffering
      ? state.evergreenOffering.commitmentReward.requiredInstallmentCount
      : 0,
    requiredSubscribableItems: getNumOfSubscribableItemsReqToCheckout(state),
    shippingCost: state.shippingCost,
    storeCode: gon.current_store.code,
    subscribableQuantity: getLineItemsSubscribableQuantity(state),
    subscribableVariantFreeFrequency: state.subscribableVariantFreeFrequency,
  };
};

export default connect(mapStateToProps)(UpsellBanner);
